import React from "react";
import { graphql } from "gatsby";
import { FormattedRichText } from "./FormattedRichText";
import {
  KontentRichText,
  KontentMultiChoice,
  MarginPaddingSizes,
} from "../../../types/index";
import { getMultiChoice } from "../../../lib/multichoice";
import { KontentComponentSettings } from "../../../types/index";

export type FormattedRichTextWidth = "full_width" | "contained" | "half_width";
interface Props extends KontentComponentSettings {
  font_size: KontentMultiChoice<
    "normal" | "x_small" | "small" | "medium" | "large" | "x_large" | "xx_large"
  >;
  text_content: KontentRichText;
  text_alignment: KontentMultiChoice<"left" | "center" | "right">;
  vertical_margins__margin_bottom: KontentMultiChoice<MarginPaddingSizes>;
  vertical_margins__margin_top: KontentMultiChoice<MarginPaddingSizes>;
  vertical_padding__padding_bottom: KontentMultiChoice<MarginPaddingSizes>;
  vertical_padding__padding_top: KontentMultiChoice<MarginPaddingSizes>;
  horizontal_margins__margin_left: KontentMultiChoice<MarginPaddingSizes>;
  horizontal_margins__margin_right: KontentMultiChoice<MarginPaddingSizes>;
  horizontal_padding__padding_left: KontentMultiChoice<MarginPaddingSizes>;
  horizontal_padding__padding_right: KontentMultiChoice<MarginPaddingSizes>;
  component_layout__component_width: KontentMultiChoice<FormattedRichTextWidth>;
}

const FormattedRichTextContainer: React.FC<Props> = (props) => {
  const fontSize = getMultiChoice(props?.font_size);
  const margin = {
    top: getMultiChoice(props.vertical_margins__margin_top),
    bottom: getMultiChoice(props.vertical_margins__margin_bottom),
    left: getMultiChoice(props.horizontal_margins__margin_left),
    right: getMultiChoice(props.horizontal_margins__margin_right),
  };
  const padding = {
    top: getMultiChoice(props.vertical_padding__padding_top),
    bottom: getMultiChoice(props.vertical_padding__padding_bottom),
    left: getMultiChoice(props.horizontal_padding__padding_left),
    right: getMultiChoice(props.horizontal_padding__padding_right),
  };
  const textAlignment = getMultiChoice(props?.text_alignment);
  return (
    <FormattedRichText
      id={props.id}
      content={props.text_content}
      fontSize={fontSize}
      textAlignment={textAlignment}
      margin={margin}
      padding={padding}
      anchor={props.component_settings__anchor_name?.value}
      hideOnMobile={
        getMultiChoice(props.component_settings__hide_on_mobile) === "yes"
      }
      width={getMultiChoice(props.component_layout__component_width)}
    />
  );
};

export default FormattedRichTextContainer;

export const fragmentFormattedRichTextContainer = graphql`
  fragment FormattedRichText on kontent_item_formatted_rich_text {
    system {
      id
      codename
    }
    internal {
      type
      contentDigest
    }
    elements {
      text_content {
        ...kontentSimpleRichText
        modular_content {
          system {
            id
            codename
          }
          internal {
            type
            contentDigest
          }
          ...kontentImage
          ...LinkedImage
        }
      }
      font_size {
        value {
          codename
        }
      }
      text_alignment {
        value {
          codename
        }
      }
      horizontal_margins__margin_left {
        value {
          codename
        }
      }
      horizontal_margins__margin_right {
        value {
          codename
        }
      }
      horizontal_padding__padding_left {
        value {
          codename
        }
      }
      horizontal_padding__padding_right {
        value {
          codename
        }
      }
      vertical_margins__margin_bottom {
        value {
          codename
        }
      }
      vertical_margins__margin_top {
        value {
          codename
        }
      }
      vertical_padding__padding_bottom {
        value {
          codename
        }
      }
      vertical_padding__padding_top {
        value {
          codename
        }
      }
      component_settings__anchor_name {
        value
      }
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
      component_layout__component_width {
        value {
          codename
        }
      }
    }
  }
`;
